import { MutationTree, ActionTree, Module } from 'vuex';
import Axios from 'axios';
import UserDTO from './UserDTO';
import ConfirmUserCommand from './ConfirmUserCommand';

export interface ManageUsersState {
  status: string;
  users: UserDTO[];
}

const USERS_GET_SUCCESS = 'USERS_GET_SUCCESS';
const USERS_GET_ERROR = 'USERS_GET_ERROR';
const USER_CONFIRM_SUCCESS = 'USER_CONFIRM_SUCCESS';
const USER_CONFIRM_ERROR = 'USER_CONFIRM_ERROR';
const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
const USER_DELETE_ERROR = 'USER_DELETE_ERROR';

export const USERS_GET_REQUEST = 'USERS_GET_REQUEST';
export const USER_CONFIRM_REQUEST = 'USER_CONFIRM_REQUEST';
export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';

const manageUsersState: ManageUsersState = {
  status: '',
  users: [],
};

const mutations: MutationTree<ManageUsersState> = {
  [USERS_GET_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USERS_GET_SUCCESS]: (state, users: UserDTO[]) => {
    state.status = 'success';
    state.users = users;
  },
  [USERS_GET_ERROR]: (state) => {
    state.status = 'error';
  },
  [USER_CONFIRM_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USER_CONFIRM_SUCCESS]: (state, userId: number) => {
    state.status = 'success';

    state.users = state.users
      .map((u) => {
        if (u.id === userId) {
          return { ...u, isConfirmed: true };
        }

        return u;
      });
  },
  [USER_CONFIRM_ERROR]: (state) => {
    state.status = 'error';
  },
  [USER_DELETE_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [USER_DELETE_SUCCESS]: (state, userId: number) => {
    state.status = 'success';

    state.users = state.users
      .filter((user) => user.id !== userId);
  },
  [USER_DELETE_ERROR]: (state) => {
    state.status = 'error';
  },
};

const actions: ActionTree<ManageUsersState, object> = {
  [USERS_GET_REQUEST]: ({ commit }) => new Promise<void>((resolve, reject) => {
    commit(USERS_GET_REQUEST);

    Axios.get<UserDTO[]>('users')
      .then(({ data }) => {
        commit(USERS_GET_SUCCESS, data);

        return resolve();
      })
      .catch(() => {
        commit(USERS_GET_ERROR);

        return reject();
      });
  }),
  [USER_CONFIRM_REQUEST]: (
    { commit },
    command: ConfirmUserCommand,
  ) => new Promise<void>((resolve, reject) => {
    commit(USER_CONFIRM_REQUEST);

    Axios.patch<void>('users/confirm', command)
      .then(() => {
        commit(USER_CONFIRM_SUCCESS, command.userId);

        return resolve();
      })
      .catch(() => {
        commit(USER_CONFIRM_ERROR);

        return reject();
      });
  }),
  [USER_DELETE_REQUEST]: (
    { commit },
    userId: number,
  ) => new Promise<void>((resolve, reject) => {
    commit(USER_DELETE_REQUEST);

    Axios.delete<void>(`users/${userId}`)
      .then(() => {
        commit(USER_DELETE_SUCCESS, userId);

        return resolve();
      })
      .catch(() => {
        commit(USER_DELETE_ERROR);

        return reject();
      });
  }),
};

const manageUsersModule: Module<ManageUsersState, object> = {
  state: manageUsersState,
  mutations,
  actions,
};

export default manageUsersModule;
